'use client';

import '@/styles/components/TeachingStyle.css';
import { useEffect, useRef, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const teachingStyleItems = [
    {
        img: '/lotties/congrats.lottie',
        title: "Результат, що змінює життя, а не просто сертифікат",
        description: "Уявіть момент, коли ви тримаєте в руках державний сертифікат з польської, що відкриває двері в університет, роботу чи нове життя в ЄС. Наші студенти складають іспити з першого разу — бо ми готуємо не до тестів, а до успіху.",
    },
    {
        img: '/lotties/gift.lottie',
        title: "Безкоштовна освіта в Польщі — не мрія, а план",
        description: "Ми не просто вчимо мову — ми допомагаємо вам вийти на програми, де ви навчаєтесь або проходите стажування в Польщі за кошти держави. Ви вивчаєте польську — а ми показуємо, як перетворити її на квиток у безкоштовне майбутнє.",
    },
    {
        img: '/lotties/chat-bubble.lottie',
        title: "Говорити з першого заняття — жити з першого тижня",
        description: "Ви не просто вивчаєте слова — ви замовляєте каву в Кракові, проходите співбесіду в Варшаві, вступаєте в університет у Вроцлаві. Ми вчимо мові, яка працює в житті — не лише в підручнику.",
    },
    {
        img: '/lotties/rocket.lottie',
        title: "Відчуй прогрес уже на першому тижні",
        description: "Наша методика дає результат швидше, ніж ви очікуєте. Ви починаєте говорити, розуміти й думати польською з перших днів — і щотижня цей прогрес тільки зростає. Бо мова — це не теорія, це практика і задоволення.",
    },
    {
        img: '/lotties/study.lottie',
        title: "Вчителі, які заряджають, а не читають лекції",
        description: "Ви відчуваєте підтримку, натхнення й драйв від кожного заняття. Наші викладачі — це ваші союзники на шляху до мови, які пояснюють складне просто і не дозволяють здатися.",
    },
    {
        img: '/lotties/travel.lottie',
        title: "Польська — не мета, а шлях до нових можливостей",
        description: "Вивчивши польську, ви не просто знаєте нову мову — ви маєте більше вибору, більше свободи, більше шансів. Робота, навчання, громадянство, нові друзі — ми допоможемо вам дійти до цього впевнено й з легкістю.",
    },
];

const TeachingStyle = () => {
    return (
        <>
            <h2 className='why-us-title'>Чому обирають саме нас</h2>
            <div className="teaching-style__container">
                <div className="teaching-style__container--grid">
                    {teachingStyleItems.map((item, index) => (
                        <TeachingStyleItem key={index} item={item} />
                    ))}
                </div>
            </div>
        </>
    );
};

const TeachingStyleItem = ({ item }) => {
    const containerRef = useRef(null);
    const [dotLottie, setDotLottie] = useState(null);

    const dotLottieRefCallback = (dotLottieInstance) => {
        setDotLottie(dotLottieInstance);
    };

    useEffect(() => {
        // Capture the current ref value at the time the effect runs
        const currentContainer = containerRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && dotLottie) {
                    // More aggressive reset approach
                    dotLottie.stop();
                    setTimeout(() => {
                        dotLottie.play();
                    }, 50);
                }
            },
            { threshold: 0.5 }
        );

        if (currentContainer) {
            observer.observe(currentContainer);
        }

        return () => {
            // Use the captured value in the cleanup function
            if (currentContainer) {
                observer.unobserve(currentContainer);
            }
        };
    }, [dotLottie]);

    return (
        <div ref={containerRef} className="teaching-style__container--grid--item">
            <div className="teaching-style-lottie-wrapper">
                <DotLottieReact
                    className="teaching-style-lottie"
                    src={item.img}
                    autoplay={false}
                    loop={false}
                    dotLottieRefCallback={dotLottieRefCallback}
                />
            </div>
            <div className="grid-description">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
            </div>
        </div>
    );
};

export default TeachingStyle;